(function() { window.GUID_25c8fe5b_3954_44fe_944a_0387a56a8d04 = { getGuid: function() { return "25c8fe5b-3954-44fe-944a-0387a56a8d04"; } }; })();
CS.FormReady(function (formId) {
    if (formId == "ReplaceEntity") {
        var btnReplaceByBye = $('#BtnReplaceByBye');
        btnReplaceByBye.on('click', function (e) {
            e.preventDefault();
            document.NewEntityBaseId.val("0", "Bye");
        });
    }
});

//# sourceMappingURL=ReplaceEntity.js.map
